// 画像の「読み込み完了フェード」。マークアップ側の <img> に data-img-fade を
// 付けるだけで効く。
//   [data-img-fade] … 読み込みが終わったら is-loaded が付き、opacity 0 → 1 で
//                     ふわっと現れる (トランジションは global.css)
//
// 初期の非表示は global.css の `html.js img[data-img-fade] { opacity:0 }` が
// 伏せている。JS 無効時はクラスが付かないため常に表示され、reduced motion では
// CSS 側で opacity:1 に戻るのでここは素通りでよい。
//
// キャッシュ済みの取りこぼしが本命の課題。このスクリプトはバンドルされた
// <script> (= defer) なので、キャッシュヒット時は実行前に load が終わっており
// 待っても永遠に来ない。img.complete を見て、その場で確定させる
// (scripts/home/hero-loader.ts と同じ考え方)。
// 読み込み失敗も error で確定させ、透明なまま居残らせない。

const LOADED = 'is-loaded';

export function initImgFade(root: ParentNode = document) {
  const images = root.querySelectorAll<HTMLImageElement>('img[data-img-fade]');

  for (const img of images) {
    if (img.classList.contains(LOADED)) continue;

    // opacity:0 の状態を最低 1 フレーム描画してからクラスを付ける。同じスタイル
    // 計算の中で 0 → 1 になるとブラウザがトランジションを省略するため、キャッシュ
    // 済み (= 即座に確定する) のときでも必ずフェードが走るようにする
    const show = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => img.classList.add(LOADED));
      });
    };

    // ダウンロード完了とペイント可能は別。decode() を待てるなら待ってから出す
    // (デコード途中の中途半端な描画を避ける)。失敗しても表示は必ず行う
    const settle = () => {
      if (typeof img.decode === 'function') img.decode().then(show, show);
      else show();
    };

    // complete は「読み込み済み」だけでなく「失敗して終了済み」でも真になる。
    // どちらにせよ待つ相手はいないのでここで確定させる
    if (img.complete) {
      settle();
      continue;
    }

    img.addEventListener('load', settle, { once: true });
    img.addEventListener('error', show, { once: true });
  }
}
